module.exports = __webpack_public_path__ + "static/media/SHIB-BNB.c6096a67.svg";